const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-1 pt-3 xl:flex-row">
      <h5 className="mb-4 w-full text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
        <p className="mb-4 text-center text-sm text-gray-600 sm:!mb-0">
          ©{1900 + new Date().getYear()} QOSKO. <br/>All Rights Reserved.
        </p>
      </h5>
      <div>        
      </div>
    </div>
  );
};

export default Footer;
